import React, { useEffect, useRef, useState } from 'react';

import './style.scss'
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputField, PhoneNumberField, SelectField } from 'views/components/form-inputs';
import * as Yup from 'yup';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
import { useFormik } from 'formik';
import { Message } from 'primereact/message';
import { promocodeService } from 'services/promocode.service';
import { _Object, showTostify } from 'utils/interfaces';
import { servicesService } from 'services';
import { useNavigate} from 'react-router-dom';
import { routes } from 'utils/routes';
import CustomToast from 'views/components/form-inputs/alert';
import axios from 'axios';
import { TabPanel, TabView } from 'primereact/tabview';
import { capitalizeFirstLetter, formatDate } from 'utils/common-functions';
import { SEOHeader } from 'views/components';
import statesData from 'static.json'
import { userService } from 'services/user.service';

interface Customer {
  id: string;
  id_number: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number1: string;
  username: string;
  city: string;
  state: string;
  reward_points: number;
  promocodes: {
    created_at: string;
    created_by: string;
    customer_id: string;
    description: string | null;
    end_date: string;
    excel_number: string | null;
    id: string;
    promocode: string;
    promocode_type: string;
    redemption_date: string;
    service_id: string;
    start_date: string;
    status: string;
    updated_at: string;
  }[];
  services: {
    code_type: string;
    commission_coins: number;
    created_at: string;
    customer_city: string;
    customer_email: string;
    customer_first_name: string;
    customer_id: string;
    customer_last_name: string;
    customer_phone_number: string;
    customer_state: string;
    discount_amount: number;
    gross_amount: number;
    id: string;
    net_amount: number;
    payment_date: string | null;
    payment_mode: string;
    payment_ref_number: string;
    redeemed_coins: number;
    redemption_code: string;
    service_number: string;
    service_store_id: string;
    title: string;
    updated_at: string;
  }[];
}

interface Username {
  id: string;
  id_number: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number1: string;
}

interface Promocode {
  id: string;
  promocode: string;
  description: string | null;
  excel_number: string | null;
  redemption_date: string | null;
  status: string;
  created_by: string;
  created_at: string;
  updated_at: string;
  service_id: string | null;
  customer_id: string | null;
}

interface Data {
  customer: Customer;
  username: Username;
  status: string;
  promocode: Promocode;
}

type Store = {
  id: string;
  title: string;
  help: string;
};

const AddServices = () => {
  const navigate = useNavigate();

  const toastRef = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const [validateLoading, setValidateLoading] = useState(false);
  const [validationResponse, setvalidationResponse] = useState<Data | null>(null);
  const [stores, setStores] = useState<Store[]>([]);
  const [selectedFile, setSelectedFile] = useState<any>('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewUrl1, setPreviewUrl1] = useState('');
  const [cities, setCities] = useState([]);

  const fetchStores = async () => {
    const response = await servicesService.getServiceStore();
    if (!response.error) {
      setStores(response.items || []);
    } else {
      showTostify(toastRef, 'error', response.message);
    }
  };

  useEffect(() => {
    fetchStores();
  }, [])

  const formik: any = useFormik({
    initialValues: {
      title: "",
      customer_first_name: validationResponse?.customer?.first_name || "",
      customer_last_name: validationResponse?.customer?.last_name || "",
      customer_email: validationResponse?.customer?.email || "",
      customer_phone_number: validationResponse?.customer?.phone_number1 || "",
      customer_username: validationResponse?.customer?.username || "",
      customer_city: validationResponse?.customer?.city || "",
      customer_state: validationResponse?.customer?.state || "",
      redemption_code: "",
      code_type: null,
      gross_amount: "",
      discount_amount: "",
      redeemed_coins: "",
      payment_mode: null,
      payment_ref_number: "",
      commission_coins: "",
      payment_date: null,
      service_store_id: "",
      customer_id: validationResponse?.customer?.id || "",
      coupons: [
        {
          name: "",
          coupon_code: ""
        }
      ]
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      customer_first_name: Yup.string().required('First name is required'),
      customer_last_name: Yup.string().required('Last name is required'),
      customer_email: Yup.string().email('Invalid email format').required('Email is required'),
      customer_username: Yup.string().required('Username is required'),
      customer_city: Yup.string().required('City is required'),
      customer_state: Yup.string().required('State is required'),
      gross_amount: Yup.string().required('Gross amount is required'),
      discount_amount: Yup.string().required('Discount amount is required'),
      redeemed_coins: Yup.number()
        .nullable() // Allows the field to be empty
        .notRequired() // Makes the field optional
        .max(validationResponse?.customer?.reward_points || 0, `Coins used must be less than or equal to ${validationResponse?.customer?.reward_points || 0}`)
        .typeError('Redeemed coins must be a number'), // Ensures the value is numeric
      coupons: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string()
              .required('Coupon name is required'), // Ensure the coupon name is not empty
            coupon_code: Yup.string()
              .required('Coupon code is required'), // Ensure the coupon code is not empty
          })
        )
        .test(
          'unique-coupon-names',
          'Coupon names must be unique',
          (coupons) => {
            const names = coupons?.map((coupon) => coupon.name);
            return new Set(names).size === names?.length; // Check for duplicate names
          }
        )
        .test(
          'unique-coupon-codes',
          'Coupon codes must be unique',
          (coupons) => {
            const codes = coupons?.map((coupon) => coupon.coupon_code);
            return new Set(codes).size === codes?.length; // Check for duplicate codes
          }
        ),

    }),
    onSubmit: async (values: any) => {
      setLoading(true);

      try {
        // Check if `validationResponse?.customer?.first_name` is empty
        if (!validationResponse?.customer?.first_name) {
          // Trigger `createUsers`
          const createUserResponse = await createUsers(values);
          if (!createUserResponse.error) {
            values.customer_id = createUserResponse.data?.id || null
            // setLoading(false);
          }
          if (createUserResponse.error) {
            showTostify(toastRef, 'error', createUserResponse.message);
            setLoading(false);
            return; // Stop execution if `createUsers` fails
          }
        }

        delete values.customer_username;
        values.redemption_code = formikValidation?.values?.promocode;
        values.payment_date = null;
        if (formikValidation?.values?.promocode) {
          values.code_type = validationResponse?.username ? "username" : "promocode";
        } else {
          values.code_type = null;
        }
        // Proceed with `createServices` after successful `createUsers`
        const data = await servicesService.createServices(values);
        console.log('data', data);

        if (!data.error) {
          if (selectedFile) {
            submitFile(data.data.id);
          }
          showTostify(toastRef, 'success', data.message);
          formik.resetForm();
          setTimeout(() => {
            navigate(routes.services);
          }, 800);
          setLoading(false);
        } else {
          formik.setFieldValue('customer_username', validationResponse?.customer?.username || "");
          showTostify(toastRef, 'error', data.message);
          setLoading(false);
        }
      } catch (err: any) {
        console.error('Error during submission:', err);
        showTostify(toastRef, 'error', err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  });

  const formikValidation: any = useFormik({
    initialValues: {
      promocode: "",
      phone_number: ""
    },
    validationSchema: Yup.object({
      // promocode: Yup.string().required('Promocode is required'),
      phone_number: Yup.string().required('Phone number is required'),
    }),
    onSubmit: async (values: any) => {
      setValidateLoading(true)
      setPreviewUrl1("")
      setPreviewUrl("")
      try {
        // delete values.type
        const data = await promocodeService.promocodesValidate(values);
        if (data.error === false) {
          setvalidationResponse(data.data);
          const selectedState: any = statesData.states.find(state => state.label === data.data?.customer?.state);
          
          if (selectedState) {
            setCities(selectedState.cities);
          } else {
            setCities([]);
          }
        } else {
          showTostify(toastRef, 'error', data.message);
        }
        setValidateLoading(false)
      } catch (err) {
        setValidateLoading(false)
        console.error('Error generating promocodes:', err);
      } finally {
        setValidateLoading(false)
      }
    }
  });

  const createUsers = async (item: _Object) => {
    const values = {
      first_name: item?.customer_first_name || null,
      last_name: item?.customer_last_name || null,
      phone_number1: item?.customer_phone_number || null,
      phone_number2: null,
      status: "active",
      role: "customer",
      username: item?.customer_username || null,
      gender: null,
      job_type: null,
      email: item?.customer_email || null,
      password: "Default@2024",
      country: "India",
      state: item?.customer_state || null,
      city: item?.customer_city || null
    };
    const data = await userService.createUsers(values);
    return data; // Return the response
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      formikValidation.handleSubmit();
    }
  };


  const handleAddCoupon = () => {
    formik.setFieldValue('coupons', [
      ...formik.values.coupons,
      { name: '', coupon_code: '' }, // Add a new empty coupon object
    ]);
  };

  const handleRemoveCoupon = (indexToRemove: number) => {
    const updatedCoupons = formik.values.coupons?.filter(
      (_: { name: string; coupon_code: string }, index: number) => index !== indexToRemove // Exclude the coupon at the given index
    );

    // Update the formik field with the new array
    formik.setFieldValue('coupons', updatedCoupons);
  };

  const selectedStore = stores.find((store: { [key: string]: string }) => store.id === formik.values.service_store_id);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target && e.target.files) {
      const file = e.target.files[0] || null;
      if (file) {
        setSelectedFile(file);
        setPreviewUrl1(URL.createObjectURL(file));
      }
    } else {
      console.error('No files were selected.');
    }
  };

  const submitFile = async (id: any) => {
    if (selectedFile) {
      const data = new FormData();
      data.append('key', 'payment_receipt');
      data.append('entity_id', `${id}`);
      data.append('files', selectedFile);

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}v1/admin/media`, data, {
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9') }
        });
				console.log(response);
				
        setPreviewUrl('')
      } catch (error) {
        console.error('Error uploading image:', error);
        alert(error);
      }
    }
  }

  const handleStateChange = (e: any) => {
    const selectedStateId = e.value;
    formik.setFieldValue('customer_state', selectedStateId);
    const selectedState: any = statesData.states.find(state => state.label === selectedStateId);
    if (selectedState) {
      setCities(selectedState.cities);
      formik.setFieldValue('customer_city', '');
    } else {
      setCities([]);
    }
  };

  return (
    <>
      <CustomToast ref={toastRef} />
      <SEOHeader title="Create Services" />

      <div className="container" style={{ width: "800px", margin: "auto" }}>
        <div className='bg-white border-round-2xl'>
          <div className="p-4 border-bottom-1 border-primary-color">
            <h2 className='text-start m-0'>Add new service</h2>
          </div>

          <form onSubmit={formikValidation.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="grid m-0 pt-4 pb-2 p-3">
              <div className="col-12 md:col-6 lg:col-5">
                <InputField
                  name="promocode"
                  label="Enter Promocode"
                  // required={true}
                  value={formikValidation?.values?.promocode}
                  onChange={formikValidation.handleChange}
                  onBlur={formikValidation.handleBlur}
                // error={formikValidation?.touched.promocode && formikValidation.errors.promocode}
                />
              </div>
              <div className="col-12 md:col-6 lg:col-5">
                <div className="form-group mb-2">
                  <label htmlFor="phone_number">Mobile<span className='required-field'>*</span></label>
                  <PhoneNumberField
                    value={formikValidation?.values?.phone_number}
                    required={true}
                    onBlur={formikValidation.handleBlur}

                    onChange={(phone) => {
                      formikValidation.setFieldValue('phone_number', phone || '')
                      formik.setFieldValue('customer_phone_number', phone || '')
                    }}
                  />
                  {formikValidation.touched.phone_number && formikValidation.errors.phone_number && (
                    <Message severity="error" text={formikValidation.errors.phone_number} />
                  )}
                </div>
              </div>

              <div className="col-2">
                <div className="form-group mb-2 ">
                  <label className='label-form mb-1' style={{ visibility: 'hidden' }}>Check</label>
                  <Button loading={validateLoading} disabled={validateLoading} type='submit' label="Check" className='primary w-full' />
                </div>
              </div>
              {validationResponse?.status &&
                <div className="col">
                  <div className="flex align-items-center gap-2">
                    <div className="form-group mb-0">
                      <label className='label-form mb-0'>Status:</label>
                    </div>
                    <Tag
                      value={validationResponse.status}
                      style={{ backgroundColor: 'transparent', border: 'none', color: 'inherit', padding: 0 }}
                    ></Tag>

                    {/* {(validationResponse?.promocode?.status === "active" || validationResponse?.username?.email) && <Tag severity="success" value="Valid"></Tag>}
                    {!validationResponse?.promocode?.status && !validationResponse?.username?.email && <Tag severity="danger" value="invalid"></Tag>} */}
                    {/* <Tag severity="warning" value="Already Used"></Tag> */}
                  </div>
                </div>
              }
            </div>
          </form>
          {!validateLoading && (validationResponse?.username || validationResponse?.promocode) &&
            <form onSubmit={formik.handleSubmit}>
              {(validationResponse?.customer?.promocodes?.length > 0 || validationResponse?.customer?.services?.length > 0) &&
                <>
                  <Divider className='mb-1' />
                  <div className="w-full add-new-service pt-0 pb-2 p-3">
                    <TabView>
                      {validationResponse?.customer?.promocodes?.length > 0 &&
                        <TabPanel header="Promocodes">
                          <table className="w-full">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Excel Number</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Created_at</th>
                              </tr>
                            </thead>
                            <tbody>
                              {validationResponse?.customer?.promocodes?.length > 0 ?
                                validationResponse?.customer?.promocodes?.map((item, i) => (
                                  <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{item?.excel_number || "-"}</td>
                                    <td>{item?.description || "-"}</td>
                                    <td>{capitalizeFirstLetter(item?.status) || "-"}</td>
                                    <td>{formatDate(item?.created_at) || "-"}</td>
                                  </tr>
                                )) :
                                <tr>
                                  <td colSpan={11}>No available options</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </TabPanel>}
                      {validationResponse?.customer?.services?.length > 0 &&
                        <TabPanel header="Services">
                          <table className="w-full">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Deal</th>
                                <th>Customer</th>
                                <th>Payment Mode</th>
                                <th>Code Type</th>
                                <th>Commission Coins</th>
                                <th>City</th>
                              </tr>
                            </thead>
                            <tbody>
                              {validationResponse?.customer?.services?.length > 0 ?
                                validationResponse?.customer?.services?.map((item, i) => (
                                  <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{item?.title || "-"}</td>
                                    <td>
                                      <strong>Name</strong>: {`${item?.customer_first_name} ${item?.customer_last_name} ` || '-'}
                                      <br />
                                      <strong>Phone</strong>: {item?.customer_phone_number || '-'}
                                      <br />
                                      <strong>Email</strong>: {item?.customer_email || '-'}
                                      <br />
                                      <strong>City</strong>: {item?.customer_city || '-'}
                                      <br />
                                      <strong>State</strong>: {item?.customer_state || '-'}
                                    </td>
                                    <td>{item?.payment_mode || "-"}</td>
                                    <td>{item?.code_type || "-"}</td>
                                    <td>{item?.commission_coins || "-"}</td>
                                    <td>{formatDate(item?.created_at) || "-"}</td>
                                  </tr>
                                ))
                                :
                                <tr>
                                  <td colSpan={11}>No available options</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </TabPanel>}
                    </TabView>
                  </div>

                  <Divider className='mb-1' />
                </>
              }

              <div className="grid m-0 pt-2 p-3">
                <div className="col-6">
                  <InputField
                    name="customer_first_name"
                    label="Customer First Name"
                    required={true}
                    value={formik.values?.customer_first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.customer_first_name && formik.errors?.customer_first_name}
                  />
                </div>

                <div className="col-6">
                  <InputField
                    name="customer_last_name"
                    label="Customer Last Name"
                    required={true}
                    value={formik.values?.customer_last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.customer_last_name && formik.errors?.customer_last_name}
                  />
                </div>

                <div className="col-6">
                  <InputField
                    name="customer_username"
                    label="Customer Username"
                    required={true}
                    value={formik.values?.customer_username}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.customer_username && formik.errors?.customer_username}
                  />
                </div>

                <div className="col-6">
                  <InputField
                    name="customer_email"
                    label="Customer Email"
                    required={true}
                    value={formik.values?.customer_email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.customer_email && formik.errors?.customer_email}
                  />
                </div>
                <div className="col-12 md:col-6 lg:col-6">
                  <SelectField
                    name="customer_state"
                    showClear
                    label="Customer State"
                    value={formik.values.customer_state}
                    onChange={handleStateChange}
                    options={statesData?.states?.map(state => ({ label: state.label, value: state.label }))}
                    error={formik.touched.customer_state && formik.errors.customer_state}
                    required={true}
                    className="my-custom-class"
                  />
                </div>

                <div className="col-12 md:col-6 lg:col-6">
                  <SelectField
                    name="customer_city"
                    showClear
                    label="Customer City"
                    value={formik.values.customer_city}
                    onChange={(e) => formik.setFieldValue('customer_city', e.value)}
                    options={cities.map(city => ({ label: city, value: city }))}
                    error={formik.touched.customer_city && formik.errors.customer_city}
                    required={true}
                    className="w-full"
                    disabled={cities.length === 0}
                  />
                </div>


                <div className="col-3">
                  <InputField
                    name="gross_amount"
                    label="Gross Amount"
                    required={true}
                    type="number"
                    value={formik.values?.gross_amount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.gross_amount && formik.errors?.gross_amount}
                  />
                </div>

                <div className="col-3">
                  <InputField
                    name="discount_amount"
                    label="Discount"
                    type="number"
                    required={true}
                    value={formik.values?.discount_amount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.discount_amount && formik.errors?.discount_amount}
                  />
                </div>

                <div className="col-4">
                  <div className="form-group mb-2">
                    <label htmlFor="redeemed_coins">Coin Used <small>(Available coins: {validationResponse?.customer?.reward_points || 0})</small></label>
                    <InputNumber
                      useGrouping={false}
                      placeholder="Enter here"
                      className='w-full'
                      name='redeemed_coins'
                      value={formik.values?.redeemed_coins}
                      onChange={(e) => formik.setFieldValue('redeemed_coins', e.value || "")}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched?.redeemed_coins && formik.errors?.redeemed_coins &&
                      <Message severity="error" text={formik.errors.redeemed_coins} />
                    }
                  </div>
                </div>

                <div className="col-2 flex align-items-center">
                  <div className="form-group mb-0">
                    <label
                      htmlFor="last_name"
                      className="flex mt-2 mb-0">
                      Net Amount &nbsp;
                      <strong> ₹{validationResponse?.customer?.reward_points || 0}</strong>
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <InputField
                    name="title"
                    label="Deal Title"
                    value={formik.values?.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched?.title && formik.errors?.title}
                  />
                </div>

                <div className="col-4">
                  <SelectField
                    name="service_store_id"
                    label="Store"
                    showClear
                    value={formik.values.service_store_id || ""}
                    onChange={(e) => formik.setFieldValue('service_store_id', e.value || "")}
                    options={stores.map((store: any) => ({ label: store.title, value: store.id }))}
                    error={formik.touched.service_store_id && formik.errors.service_store_id}
                    className="my-custom-class"
                  />
                </div>

                <div className="col-4">
                  <SelectField
                    name="commission_coins"
                    label="Commission Coins"
                    showClear
                    value={formik.values.commission_coins || ""}
                    onChange={(e) => formik.setFieldValue('commission_coins', e.value)}
                    options={[
                      { label: '10', value: '10' },
                      { label: '20', value: '20' },
                      { label: '30', value: '30' },
                      { label: '40', value: '40' },
                      { label: '50', value: '50' },
                    ]}
                    disabled={!validationResponse?.username?.id}
                    error={formik.touched.commission_coins && formik.errors.commission_coins}
                    className="my-custom-class"
                  />
                </div>

                <div className="col-6 px-0">
                  <div className="col">
                    <SelectField
                      name="payment_mode"
                      label="Payment Mode"
                      showClear={formik.values.payment_mode}
                      value={formik.values.payment_mode || null}
                      onChange={(e) => formik.setFieldValue('payment_mode', e.value)}
                      options={[
                        { label: 'Cash', value: 'cash' },
                        { label: 'PhonePe', value: 'phonepe' },
                        { label: 'Google Pay', value: 'googlepay' },
                        { label: 'Paytm', value: 'paytm' },
                        { label: 'Bank Transfer', value: 'bank_transfer' },
                        { label: 'Other', value: 'other' }
                      ]}
                      error={formik.touched.payment_mode && formik.errors.payment_mode}
                      className="my-custom-class"
                    />
                  </div>

                  <div className="col">
                    <InputField
                      name="payment_ref_number"
                      label="Ref. No."
                      value={formik.values?.payment_ref_number}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched?.payment_ref_number && formik.errors?.payment_ref_number}
                    />
                  </div>

                  <div className="col">
                    <div className='form-group mb-2 '>
                      <label className="label-form mb-1">Payment Receipt</label>
                    </div>

                    <ul className="fileupload p-list p-list-custom list-none flex flex-wrap gap-2 p-0 m-0">
                      {previewUrl1 && (
                        <li className="p-list-item">
                          <img
                            src={previewUrl1}
                            alt=""
                            width={80}
                            height={80}
                          />
                        </li>
                      )}
                      <li className="p-list-item">
                        <div className="avatar-upload">
                          <label htmlFor="imageUpload">
                            <i className="pi pi-cloud-upload" style={{ fontSize: '20px' }}></i>
                          </label>
                          <input
                            type="file"
                            id="imageUpload"
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => {
                              handleImageChange(e);
                            }}
                            style={{ visibility: 'hidden' }}
                          />
                          <div className="avatar-preview">
                            <div className="image-preview">
                              {previewUrl && (
                                <img src={previewUrl} alt="Avatar Preview" width={200} height={200} />
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-6">
                  <div className="form-group mb-3">
                    <label htmlFor="last_name">Store Help</label>

                    <p className="mt-0" style={{ fontWeight: 'normal' }}>{selectedStore?.help || "-"}</p>
                    {/* <p className="mt-0" style={{ fontWeight: 'normal' }}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat expedita soluta repellendus.</p> */}
                  </div>

                  <div className="col-12">
                    <div className="grid p-2 pb-1 border-1 border-primary-color border-round" style={{ backgroundColor: "#3139570D" }}>
                      {formik.values.coupons.map((coupon: { [key: string]: string }, index: number) => (
                        <React.Fragment key={index}>
                          <div className="col-5">
                            <InputField
                              name={`coupons[${index}].name`}
                              label="Coupon Name"
                              required={true}
                              value={coupon.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={
                                formik.touched.coupons?.[index]?.name && formik.errors.coupons?.[index]?.name
                                  ? 'p-invalid'
                                  : ''
                              }
                              error={formik?.touched.coupons?.[index]?.name && formik.errors.coupons?.[index]?.name}
                            />
                          </div>

                          <div className="col-5">
                            <InputField
                              name={`coupons[${index}].coupon_code`}
                              label="Coupon Code"
                              required={true}
                              value={coupon.coupon_code}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={
                                formik.touched.coupons?.[index]?.coupon_code &&
                                  formik.errors.coupons?.[index]?.coupon_code
                                  ? 'p-invalid'
                                  : ''
                              }
                              error={formik?.touched.coupons?.[index]?.coupon_code && formik.errors.coupons?.[index]?.coupon_code}
                            />
                          </div>
                          {(formik.values.coupons?.length - 1) === index ? (
                            <div className="flex align-items-end p-2">
                              <Button
                                type="button"
                                icon="pi pi-plus"
                                rounded
                                severity="success"
                                onClick={handleAddCoupon} // Add coupon on button click
                                className="mb-3 p-2 min-h-0 h-2rem w-2rem"
                              />
                            </div>
                          ) : (
                            <div className="flex align-items-end p-2">
                              <Button
                                type="button"
                                icon="pi pi-minus"
                                rounded
                                severity="danger"
                                onClick={() => handleRemoveCoupon(index)} // Remove coupon on button click
                                className="mb-3 p-2 min-h-0 h-2rem w-2rem"
                              />
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                      {typeof formik?.errors?.coupons === "string" && <div className="col pl-2 pt-0">
                        <div className={`form-group mb-0`}>
                          <Message severity="error" text={formik?.errors?.coupons || ""} />
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>

                <div className="col-12 text-center">
                  <Button loading={loading} disabled={loading} type='submit' label="Give Service" className='primary' />
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    </>
  );
};

export default AddServices;

